import { cloneDeep } from 'lodash';
import React, { useState, useEffect } from 'react';

function Hours({ slots, hour, onHourChange, equipments, showDetails = false, type = "buttons" }) {
  const [availableSlots, setAvailableSlots] = useState(slots);

  const check = () => {
    // if (!equipments.length) return setAvailableSlots(slots);
    // sprawdzenie czy w danej godzinie jest wystarczajaca ilosc miejsc
    let newSlots = cloneDeep(slots);
    newSlots = newSlots.filter(slot => {
      let isOk = true;

      equipments.forEach(equipment => {
        const e = slot.equipmentsToTrail.find(x => x.id === equipment.equipmentToTrailId)
        if (e.available < equipment.count) {
          // console.log(slot, equipment, e)
          // console.log(`Za mała ilość sprzętu "${e.equipment.title}" (eqToTrailId: ${e.id}), o godzinie ${slot.startTimeHuman}. Wybrano: ${equipment.count}, dostępnych: ${e.available}.`);
          isOk = false;
          // wyzeruj godzine, jesli akurat ta brakujaca byla wybrana
          if (hour === slot.startTimeHuman) onHourChange('');
        }
      });
      return isOk;
    });
    setAvailableSlots(newSlots);
  }

  useEffect(() => {
    check()
  }, [equipments, slots]);


  return availableSlots.length ? (
    <div className="form-group mb-3">
      <label htmlFor="hour" className="form-label">Dostępne godziny spływu <span className="text-danger">*</span></label>

      <button 
        className="btn btn-sm btn-outline-secondary" 
        style={{ borderRadius: '100px', padding: '4px 10px', marginLeft: 10, float: 'right' }}
        onClick={() => onHourChange('')}>
        Resetuj godzinę
      </button>
      <p><small className="text-muted">Po wybraniu godziny, ilość dostępnych pozycji sprzętu zostanie zaktualizowana.</small></p>

      <div style={{ position: 'relative' }}>

        {type !== 'select' && availableSlots.map(slot => (
          <div className="order-radio-container" key={slot.startTimeMinutes}>
            <input
              name="hour"
              type="radio"
              checked={hour === slot.startTimeHuman}
              onChange={() => onHourChange(slot.startTimeHuman)}
              id={`hour-${slot.startTimeMinutes}`}
            /> <label htmlFor={`hour-${slot.startTimeMinutes}`}>{slot.startTimeHuman} 
              {showDetails && <>&nbsp; {slot.equipmentsToTrail.map(ett => <>&nbsp; {ett.equipment.title}: {ett.available}</>)}</>}
            </label>
          </div>
        ))}

        {type === 'select' && <>
          <select className="form-control" name="hour" onChange={() => onHourChange(e.target.value)}>
            {availableSlots.length > 0 
              ? <option>Wybierz godzinę</option>
              : <option>Brak dostępnych godzin</option>
            }

            {availableSlots.map(slot => (
              <option 
                key={slot.startTimeMinutes}
                selected={hour === slot.startTimeHuman}
                value={slot.startTimeHuman}
              >
                {slot.startTimeHuman} &nbsp; 
                {showDetails && slot.equipmentsToTrail.map(ett => ` ${ett.equipment.title}: ${ett.available} `)}
              </option>
            ))}
          </select>
        </>}
        
      </div>
    </div>
  ) : (
    <div className="alert alert-danger">
      Brak dostępnych godzin. Wybierz inny dzień lub zmień ilość kajaków.
    </div>
  );
}

export default Hours;